import React from 'react';
import PropTypes from 'prop-types';
import availableIcons from './available-icons';
import './iconPicker.scss';




const AvatarViewer = (props) => {
    const {
        avatar = '',
        className = ''
    } = props;



    return (

        <img className={`${className}`} src={`${availableIcons[avatar]}`} alt='avatar' />

    );
}

AvatarViewer.propTypes = {
    avatar: PropTypes.string,
    className: PropTypes.string,
}

export default AvatarViewer;